import { DayExperienceTaxonomyResponse } from "./api/DayExperienceResponse";
import { Category, Island } from "./DayExperience";

export class DayExperienceTaxonomy {
  islands: Island[];
  categories: Category[];

  constructor(resp?: DayExperienceTaxonomyResponse) {
    this.islands = resp?.islands.map((i) => new Island(i)) ?? [];
    this.categories = resp?.categories.map((c) => new Category(c)) ?? [];
  }
}
